// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2GS6g","colMaxWidth":"Table_colMaxWidth__12RPU"};